import React, { createContext, useContext, useEffect, useState } from 'react';
import type { PageTourDefinition } from './pageTourTypes';

type SetTour = React.Dispatch<React.SetStateAction<PageTourDefinition | null>>;

// Contextos separados: registrar un tour no re-renderiza las pantallas, solo a quien lo lee.
const TourContext = createContext<PageTourDefinition | null>(null);
const SetTourContext = createContext<SetTour | null>(null);

export const PageTourProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [tour, setTour] = useState<PageTourDefinition | null>(null);
  return (
    <SetTourContext.Provider value={setTour}>
      <TourContext.Provider value={tour}>{children}</TourContext.Provider>
    </SetTourContext.Provider>
  );
};

/** Tour de la pantalla montada (o `null`). */
export function useCurrentPageTour(): PageTourDefinition | null {
  return useContext(TourContext);
}

/**
 * Declara el tour de la pantalla mientras está montada. El tour viaja con el componente,
 * así que funciona en cualquier ruta donde se use.
 */
export function useRegisterPageTour(tour: PageTourDefinition | null) {
  const setTour = useContext(SetTourContext);
  useEffect(() => {
    if (!setTour || !tour) return undefined;
    setTour(tour);
    return () => setTour((current) => (current === tour ? null : current));
  }, [setTour, tour]);
}
